import { CookieUtil } from './CookieUtil';

export enum ConsentCookieTypes {
  STATISTIC,
  PERSONAL,
  MARKETING
}

// Werte die ein Cookie annehmen kann
export enum CookieValues {
  ACCEPTED = 'accepted',
  DENIED = 'denied'
}

export class ConsentCookieUtil extends CookieUtil {
  private static readonly sekProTag = 86400;
  private static maxAgeTage = 30;
  private static readonly umrechnungsfaktorMsZuS = 1000;

  // Name des cookies für statistische und personalisierungs Zwecke
  private static readonly statisticCookieName = 'cookie_consent';
  private static readonly personalCookieName = 'personalization_consent';
  private static readonly marketingCookieName = 'marketing_consent';

  /**
   * Setzt einen Consent Cookie in das HTMLDocument. Dabei kann bestimmt werden, ob der der Consent "accepted" oder "denied" ist.
   * Der gesetzte Cookie hat ein "max-age" von 30 Tagen (2.592.000s bzw. 2.592.000.000ms).
   * Für den Support älterer Browser (IE8, 9, 10) wird das Attribut "expires" gesetzt.
   *
   * Für die Einwilligung von Statistischen Cookies ("statistic") wird der Cookie "cookie_consent" gesetzt.
   * (zu Beachten: Der name "cookie_consent" wurde für die Abwärtskompatibilität zu Analysetoole wie bspw. Piwik übernommen.)
   *
   * Für die Einwilligung von Persönlichen Cookies ("personal") wird der Cookie "personalization_consent" gesetzt.
   *
   * @param type Typ des Consent-Cookies
   * @param accepted true für "accepted" oder false für "denied" (Default: true)
   */
  static setConsentCookie(type: ConsentCookieTypes, accepted: boolean = true) {
    let cookieName;
    switch (type){
      case ConsentCookieTypes.STATISTIC: cookieName = this.statisticCookieName; break;
      case ConsentCookieTypes.PERSONAL: cookieName = this.personalCookieName; break;
      case ConsentCookieTypes.MARKETING: cookieName = this.marketingCookieName; break;
      default: cookieName = null;
    }

    let age = type === ConsentCookieTypes.MARKETING ? 180 : this.maxAgeTage;

    const cookieValue = this.getCookieContentValue(accepted);
    const cookieMaxAge = age * this.sekProTag; // in seconds
    const cookieExpiresDate = new Date(Date.now() + cookieMaxAge * this.umrechnungsfaktorMsZuS);

    super.setCookie(cookieName, cookieValue, cookieMaxAge, cookieExpiresDate);
  }

  /**
   * Gibt den Wert ("accepted", "denied") eines angegebenen Consent-Cookies aus dem HTMLDocument zurück.
   * Ist der spezifizierte Cookie nicht vorhanden wird null zurückgegeben.
   *
   * @param type Typ des Consent-Cookies
   */
  static getConsentCookie(type: ConsentCookieTypes) {
    let cookieName;
    switch (type){
      case ConsentCookieTypes.STATISTIC: cookieName = this.statisticCookieName; break;
      case ConsentCookieTypes.PERSONAL: cookieName = this.personalCookieName; break;
      case ConsentCookieTypes.MARKETING: cookieName = this.marketingCookieName; break;
      default: cookieName = null;
    }

    const value = super.getCookieValue(cookieName);
    if (value !== CookieValues.ACCEPTED && value !== CookieValues.DENIED) {
      return null;
    }
    return value;
  }

  static getCookieContentValue(boolean:boolean) {
    return boolean ? CookieValues.ACCEPTED : CookieValues.DENIED;
  }
}
